// Mock data for SBF Home Improvements LLC

export const businessInfo = {
  name: "SBF Home Improvements LLC",
  license: "PA 159448",
  phone: "(724) 420-6192",
  email: "sbfhomeimprovements20@gmail.com",
  address: "Mt Pleasant, PA",
  hours: "Mon-Fri: 7:00 AM - 6:00 PM, Sat: 8:00 AM - 4:00 PM",
  serviceAreas: ["Fayette County (15666)", "Mt Pleasant", "Scottdale", "Connellsville", "Uniontown", "20-Mile Radius"]
};

export const services = [
  {
    id: 1,
    title: "Roof Replacements",
    description: "Complete roof replacement services using premium materials. We handle everything from tear-off to final installation with a focus on durability and protection.",
    icon: "Home",
    features: ["Asphalt Shingles", "Metal Roofing", "Emergency Repairs", "Free Inspections"]
  },
  {
    id: 2,
    title: "Siding Replacements",
    description: "Transform your home's exterior with quality siding installation. We offer various materials and styles to match your home's aesthetic and budget.",
    icon: "Building2",
    features: ["Vinyl Siding", "Fiber Cement", "Wood Siding", "Color Matching"]
  },
  {
    id: 3,
    title: "Flooring Installation",
    description: "Professional flooring installation for any room in your home. From hardwood to tile, we ensure precise installation and beautiful results.",
    icon: "Grid3x3",
    features: ["Hardwood Floors", "Laminate", "Tile & Stone", "Vinyl Plank"]
  },
  {
    id: 4,
    title: "General Repairs",
    description: "No job too small! We handle all types of home repairs including drywall, painting, deck repairs, and general maintenance to keep your home in top shape.",
    icon: "Wrench",
    features: ["Drywall Repair", "Painting", "Deck Repairs", "Door/Window Repair"]
  }
];

export const gallery = [
  {
    id: 1,
    category: "Roofing",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/8phmc4ir_20241028_123522%20%281%29.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/3hbrfec1_dji_fly_20241115_130536_0042_1731694016409_photo.jpg",
    title: "Complete Roof Replacement - Stone Exterior Home",
    description: "Full roof replacement with premium asphalt shingles"
  },
  {
    id: 2,
    category: "Roofing",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/4pikmrwn_dji_fly_20241008_093436_4_1728394513183_photo_optimized.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/ao5buk3f_dji_fly_20241012_125344_26_1728769243552_photo_optimized.jpg",
    title: "Residential Roof Replacement",
    description: "Quality shingle installation with improved weather protection"
  },
  {
    id: 3,
    category: "Siding",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/74tkai91_20230712_155854.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/1e3q3ntv_20231003_160959.jpg",
    title: "Modern Dark Siding Installation",
    description: "Complete exterior transformation with premium dark board and batten siding"
  },
  {
    id: 4,
    category: "Siding",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/ekaeysy1_20230807_120902.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/nv8qlzmn_received_1396827941272260.jpeg",
    title: "Gray Vinyl Siding Replacement",
    description: "Fresh vinyl siding installation replacing deteriorated exterior"
  },
  {
    id: 5,
    category: "Deck Construction",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/hfy9yj6x_20230627_161747%20%281%29.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/3oub6816_20230913_164253.jpg",
    title: "Multi-Level Deck Rebuild with Cable Railings",
    description: "Complete deck replacement featuring modern cable railing system and professional staining"
  },
  {
    id: 6,
    category: "Room Addition",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/i9omauhu_20240326_162240.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/4qwteglp_20240920_142611%280%29.jpg",
    title: "Porch to Room Addition",
    description: "Custom room addition from framing to finished interior space"
  },
  {
    id: 7,
    category: "Flooring",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/fkyefu1s_20250514_104938.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/990p0rni_20250522_161235.jpg",
    title: "Hardwood Floor Installation",
    description: "Beautiful hardwood flooring transformation"
  },
  {
    id: 8,
    category: "Roofing",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/cuovuwm6_dji_fly_20251018_130356_0153_1763427362423_photo.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/07mtsskh_dji_fly_20251117_123216_0160_1763400822572_photo%20%282%29.jpg",
    title: "Historic 150-Year-Old Farmhouse Metal Roof Restoration",
    description: "Pressure washed, scraped, and coated crimped tin roof with Gaco roof sealant - Norvelt, PA"
  },
  {
    id: 9,
    category: "Flooring",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/64dndtzo_20250623_125527.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/war3xm0c_20250627_175000.jpg",
    title: "Historic Kitchen Floor Restoration - 100-Year-Old Ohiopyle House",
    description: "Complete floor restoration with new vintage ceramic octagonal kitchen tile"
  },
  {
    id: 10,
    category: "Roofing",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/ptaw39yq_20250424_164120.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/v65agvjw_20250620_175246.jpg",
    title: "Custom Porch Build with Copper Metal Roofs - Jumonville, PA",
    description: "Built new porch and installed beautiful copper metal roofs on both porches"
  },
  {
    id: 11,
    category: "Deck Construction",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/p21hljdm_20240516_163425.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/d1zzpewn_20240920_161903.jpg",
    title: "24x15 Free-Standing Covered Porch - Ohiopyle, PA",
    description: "Custom free-standing porch following roof lines with pine T&G ceiling, French door, and heavy-duty construction built to last"
  },
  {
    id: 12,
    category: "Deck Construction",
    before: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/rwwt5lml_20250429_145011.jpg",
    after: "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/2sk5kr7n_20250301_110911%20%281%29.jpg",
    title: "18x9 Custom Cedar Porch - Chalkhill Lakeside Home, PA",
    description: "Custom cedar post and trim porch with picture-framed decking and routed transitions, expertly blended with existing home"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "John Martinez",
    location: "Pittsburgh, PA",
    rating: 5,
    text: "SBF Home Improvements replaced our entire roof and the team was professional, efficient, and cleaned up perfectly. The quality of work exceeded our expectations!",
    service: "Roof Replacement"
  },
  {
    id: 2,
    name: "Sarah Thompson",
    location: "Butler County, PA",
    rating: 5,
    text: "Had new siding installed on our home and it looks amazing! The crew was respectful, on time, and completed the job within the estimated timeframe. Highly recommend!",
    service: "Siding Installation"
  },
  {
    id: 3,
    name: "Michael Chen",
    location: "Allegheny County, PA",
    rating: 5,
    text: "From start to finish, the flooring installation was smooth. They helped us choose the right materials and the installation was flawless. Our home looks brand new!",
    service: "Flooring Installation"
  },
  {
    id: 4,
    name: "Jennifer Davis",
    location: "Westmoreland County, PA",
    rating: 5,
    text: "Quick response for emergency repairs. Fixed our deck and some interior drywall damage. Fair pricing and excellent craftsmanship. Will definitely use them again!",
    service: "General Repairs"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Are you licensed and insured?",
    answer: "Yes, we are fully licensed (PA License #159448) and insured. We carry comprehensive liability insurance and workers' compensation coverage for your protection."
  },
  {
    id: 2,
    question: "Do you offer free estimates?",
    answer: "Absolutely! We provide free, no-obligation estimates for all our services. Simply contact us to schedule an appointment."
  },
  {
    id: 3,
    question: "What areas do you serve?",
    answer: "We proudly serve Pittsburgh and surrounding areas including Allegheny County, Butler County, and Westmoreland County."
  },
  {
    id: 4,
    question: "How long does a typical project take?",
    answer: "Project timelines vary based on scope. Roof replacements typically take 1-3 days, siding projects 3-7 days, and flooring 2-5 days. We'll provide a detailed timeline during your estimate."
  },
  {
    id: 5,
    question: "Do you warranty your work?",
    answer: "Yes! We stand behind our work with comprehensive warranties. Specific warranty terms depend on the type of work and materials used, which we'll discuss during your consultation."
  }
];